import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { ConsentPolicySiteConfig } from '../types'

const consentPolicySiteConfig: SiteConfigFn<ConsentPolicySiteConfig> = ({ api }) => {
	const siteConsentPolicy = api.rendererModel.getConsentPolicy()!
	const isWixSite = api.rendererModel.getSiteInfo()?.documentType === 'WixSite'
	const isBuilderComponentModel = !!api.rendererModel.getSiteMetaData()?.builderComponentModel

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig: {
			siteConsentPolicy,
			isWixSite,
			isBuilderComponentModel,
		},
	}
}

const name = 'consentPolicy'

export const config = { site: consentPolicySiteConfig, name }
